import { forwardRef, useEffect, useRef, useState } from "react";
import { Marker, Popup } from "react-leaflet";

import clientComponent from "../../../config/clientComponents";

const CustomMarker = forwardRef(
  (
    {
      entity,
      MarkerIcon,
      setSelectedInstitution,
      scrollbarInstance,
      lineRefs,
      i,
      colorsArray,
      innerIcon,
      popupRefs,
      filtersKeys,
    },
    ref
  ) => {
    let MarkerPopup = {};
    if (process.env.REACT_APP_POPUP === "true") {
      MarkerPopup = clientComponent["MarkerPopup"];
    }

    return (
      <Marker
        icon={MarkerIcon}
        key={entity.id}
        position={[entity.latitude, entity.longitude]}
        calc={entity}
        eventHandlers={{
          click: (e) => {
            e.target.refreshIconOptions(null, true);
            setSelectedInstitution(entity);
            if (process.env.REACT_APP_SIDEBAR !== "none") {
              const { viewport } = scrollbarInstance.elements();
              viewport.scrollTo({
                top: lineRefs.current[i].current.offsetTop,
                behavior: "smooth",
              });
            }
          },
        }}
        ref={ref}
      >
        {process.env.REACT_APP_POPUP === "true" && (
          <Popup
            options={entity}
            ref={popupRefs.current[i]}
            autoPanPaddingTopLeft={[50, 50]}
            autoPanPaddingBottomRight={[50, 50]}
            className="my-marker-popup"
          >
            <h4>{entity.name}</h4>
            <a
              target="_blank"
              href={`https://maps.google.com/maps?daddr=${entity.latitude},${entity.longitude}&ll=`}
            >
              {entity.address}
            </a>
          </Popup>
        )}
      </Marker>
    );
  }
);
export default CustomMarker;
